import { QueryClientProvider } from '@tanstack/react-query'
import { createRoot } from 'react-dom/client'
import { Popup } from '@maptiler/sdk'

import PropsList from './PropsList/PropsList'

const getLngLat = (coordinates) => {
  if (Array.isArray(coordinates) && coordinates.length >= 2) {
    return [coordinates[0], coordinates[1]]
  }

  if (coordinates && typeof coordinates === 'object') {
    const { lng, lat } = coordinates
    if (typeof lng === 'number' && typeof lat === 'number') {
      return [lng, lat]
    }
  }

  return null
}

const createListPopup = ({ map, coordinates, props, queryClient, userId }) => {
  const lngLat = getLngLat(coordinates)
  if (!map || !lngLat) return null

  const container = document.createElement('div')
  const root = createRoot(container)

  const popup = new Popup()

  root.render(
    <QueryClientProvider client={queryClient}>
      <PropsList
        popup={popup}
        props={props}
        queryClient={queryClient}
        userId={userId}
      />
    </QueryClientProvider>,
  )

  popup
    .setLngLat(lngLat)
    .setDOMContent(container)
    .addTo(map)

  // Remove popup on map zoom
  const onZoom = () => {
    popup.remove()
  }
  map.on('zoom', onZoom)

  popup.on('close', () => {
    map.off('zoom', onZoom)
    root.unmount()
  })

  return popup
}

export default createListPopup
